"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimLabel = void 0;
const moment = require("moment-timezone");
const pdfs_1 = require("client/modules/orders/modules/pdfs");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const print_util_1 = require("../../print-util");
/**
 * Page 2
 * - Claim label
 */
class ClaimLabel extends print_util_1.PrintUtil {
    constructor(printMeta, lastPage) {
        super();
        this.printMeta = printMeta;
        this.lastPage = lastPage;
        this.make = () => {
            var _a, _b, _c, _d, _e, _f, _g;
            const { claim, barcode, providerSignature, icd10s, historic } = this.printMeta;
            const currentClaim = mobx_1.toJS(claim);
            const { order } = currentClaim;
            const inventoryItem = (_a = historic === null || historic === void 0 ? void 0 : historic.inventoryData) !== null && _a !== void 0 ? _a : currentClaim.inventory;
            const patient = (_b = historic === null || historic === void 0 ? void 0 : historic.patientData) !== null && _b !== void 0 ? _b : order.patient;
            const provider = (_c = historic === null || historic === void 0 ? void 0 : historic.providerData) !== null && _c !== void 0 ? _c : order.provider;
            const hasSupervisor = provider.id !== order.site.picProviderId;
            const site = (_d = historic === null || historic === void 0 ? void 0 : historic.siteData) !== null && _d !== void 0 ? _d : order.site;
            const { claimLots } = currentClaim;
            const originalOrder = currentClaim.originalOrder || null;
            const orderDate = originalOrder
                ? originalOrder.createDate
                : currentClaim.date;
            const multiLineRx = site.state === "SC" || site.state === "NC";
            const user = (_e = historic === null || historic === void 0 ? void 0 : historic.userData) !== null && _e !== void 0 ? _e : store_1.usersStore.user.value;
            const pageBreak = this.lastPage ? "" : "after";
            return [
                {
                    alignment: "center",
                    stack: [
                        {
                            bold: true || "",
                            text: `${provider.prefix.toUpperCase()} ${provider.firstName.toUpperCase() ||
                                ""} ${provider.lastName.toUpperCase() ||
                                ""} ${provider.suffix.toUpperCase()}, ${provider.title.toUpperCase() ||
                                ""}`
                        },
                        `${hasSupervisor
                            ? `NPI: ${provider.npiNumber || ""} DEA#: ${provider.dea ||
                                ""} Lic #: ${provider.state.toUpperCase() ||
                                ""} ${provider.stateLicense || ""}`
                            : ""}`,
                        `${site.name}`,
                        `${site.address || ""}`,
                        `${site.city || ""}, ${site.state || ""} ${site.zip || ""}`,
                        `Phone: ${site.phone || ""} ${" ".repeat(5)}Fax: N/A`,
                        "\n",
                        {
                            bold: true,
                            text: provider.id !== site.picProviderId
                                ? `Supervising Provider: ${site.picProvider.lastName ||
                                    ""}, ${site.picProvider.firstName || ""} ${site.picProvider
                                    .title || ""}`
                                : ""
                        },
                        `NPI: ${hasSupervisor
                            ? site.picProvider.npiNumber
                            : provider.npiNumber || ""} ${" ".repeat(5)}DEA#: ${hasSupervisor ? site.picProvider.dea : provider.dea || ""} ${" ".repeat(5)}Lic #: ${hasSupervisor
                            ? site.picProvider.state.toUpperCase()
                            : provider.state.toUpperCase() || ""} ${hasSupervisor
                            ? site.picProvider.stateLicense
                            : provider.stateLicense || ""}`
                    ],
                    style: "tableTextNoMargin",
                    width: "*"
                },
                {
                    alignment: "center",
                    columnGap: 10,
                    columns: [
                        {
                            text: "",
                            width: "*"
                        },
                        {
                            alignment: "left",
                            text: ["Patient Name:", "\nAddress:", "\n\nDOB:", "\nHome:"],
                            width: "auto"
                        },
                        {
                            alignment: "left",
                            text: [
                                `${patient.lastName.toUpperCase() ||
                                    ""}, ${patient.firstName.toUpperCase() || ""}
                ${patient.address || ""}
                ${patient.state || ""}, ${patient.zip || ""}
                ${patient.birthDate || ""} (${moment().diff(patient.birthDate, "years")} yr old) / ${patient.gender || ""}
                ${patient.phone || ""}`
                            ],
                            width: 150
                        },
                        {
                            alignment: "left",
                            text: [
                                `Written: ${moment(this.orderCreateDate(orderDate)).format("MMM Do, YYYY") || ""}`
                            ],
                            width: 100
                        },
                        {
                            text: "",
                            width: "*"
                        }
                    ],
                    style: "tableTextNoMargin",
                    width: "*"
                },
                {
                    alignment: "center",
                    columns: [
                        {
                            text: "",
                            width: "*"
                        },
                        {
                            image: pdfs_1.rxImg,
                            width: 50
                        },
                        {
                            text: "",
                            width: 200
                        },
                        {
                            image: barcode,
                            width: 100
                        },
                        {
                            text: "",
                            width: "*"
                        }
                    ],
                    style: "tableTextNoMargin",
                    width: "*"
                },
                {
                    stack: [
                        `${inventoryItem.name || ""}
            Disp: #${currentClaim.quantity * inventoryItem.disQty || ""}
            Sig: ${inventoryItem.defaultSig || ""}
            Refill: ${`${inventoryItem.refills} Times` || "N/A"} ${" ".repeat(5)}Days Supply: ${inventoryItem.daysSupply || "N/A"}
            -`
                    ],
                    style: "drugInfo"
                },
                {
                    stack: multiLineRx
                        ? [
                            {
                                absolutePosition: { x: 360, y: 440 },
                                image: providerSignature,
                                style: "dispenseAsWritten",
                                width: 100
                            },
                            {
                                absolutePosition: { x: 265, y: 400 },
                                style: "prescriberAgent",
                                text: `${provider.lastName.padStart(30, " ")}, ${provider.firstName.padEnd(30, " ")}${provider.title}`
                            },
                            {
                                relativePosition: { x: 245, y: 55 },
                                style: "description",
                                text: "Prescriber Agent"
                            }
                        ]
                        : [
                            {
                                absolutePosition: { x: 265, y: 395 },
                                image: providerSignature,
                                style: "dispenseAsWritten",
                                width: 100
                            },
                            {
                                absolutePosition: { x: 440, y: 410 },
                                style: "prescriberAgent",
                                text: " ".repeat(100)
                            },
                            {
                                absolutePosition: { x: 145, y: 405 },
                                style: "description",
                                text: "Signature:"
                            }
                        ]
                },
                {
                    stack: multiLineRx
                        ? [
                            {
                                absolutePosition: { x: 290, y: 450 },
                                style: "prescriberAgent",
                                text: " ".repeat(81)
                            },
                            {
                                absolutePosition: { x: 155, y: 470 },
                                style: "description",
                                text: site.state === "NC"
                                    ? "Dispense As Written"
                                    : "Substitution Permissible"
                            }
                        ]
                        : []
                },
                {
                    stack: multiLineRx
                        ? [
                            {
                                absolutePosition: { x: 475, y: 450 },
                                style: "prescriberAgent",
                                text: " ".repeat(56)
                            },
                            {
                                absolutePosition: { x: 360, y: 470 },
                                style: "description",
                                text: site.state === "NC"
                                    ? "Substitution Permissible"
                                    : "Dispense As Written"
                            }
                        ]
                        : []
                },
                {
                    stack: multiLineRx
                        ? [
                            {
                                absolutePosition: { x: 50, y: 490 },
                                alignment: "center",
                                style: "tableText",
                                text: `ICD10: ${icd10s}`
                            }
                        ]
                        : [
                            {
                                absolutePosition: { x: 50, y: 440 },
                                alignment: "center",
                                style: "tableText",
                                text: `ICD10: ${icd10s}
                Signature of physician must appear on line above
                In Order for the brand name product to be dispensed the prescriber
                must write "Medically Necessary" BELOW the signature.`
                            }
                        ]
                },
                // STICKER CLONE FROM LABEL PAGE
                {
                    absolutePosition: { x: 220, y: 560 },
                    layout: {
                        hLineColor: () => "gray",
                        vLineColor: () => "gray"
                    },
                    pageBreak,
                    table: {
                        body: [
                            [
                                {
                                    stack: [
                                        {
                                            style: "header",
                                            text: `${site.name || ""}\n`,
                                            bold: true,
                                            margin: [0, 2, 0, 0]
                                        },
                                        {
                                            table: {
                                                body: [
                                                    [
                                                        {
                                                            text: `RX:`,
                                                            bold: true
                                                        },
                                                        [
                                                            {
                                                                text: `${currentClaim.rxId.rxId}-${currentClaim.fillNumber}`,
                                                                bold: true
                                                            },
                                                            {
                                                                text: `${patient.lastName ||
                                                                    ""}, ${patient.firstName || ""}`,
                                                                bold: true
                                                            },
                                                            {
                                                                text: `${patient.address || ""}, ${patient.city ||
                                                                    ""}, ${patient.state} ${patient.zip || ""}`,
                                                                fontSize: 4
                                                            }
                                                        ]
                                                    ]
                                                ],
                                                style: { border: 0 }
                                            },
                                            layout: "noBorders"
                                        },
                                        {
                                            table: {
                                                body: [
                                                    [
                                                        {
                                                            text: [
                                                                { text: `Phone: `, fontSize: 5, bold: true },
                                                                {
                                                                    text: `${patient.phoneNumber ||
                                                                        "(000) 000-0000"}`,
                                                                    fontSize: 5,
                                                                    margin: [0, -5, 0, 0]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            text: [
                                                                {
                                                                    text: "DOB: ",
                                                                    fontSize: 5,
                                                                    margin: [0, -5, 0, 0],
                                                                    bold: true
                                                                },
                                                                {
                                                                    text: `${patient.birthDate || "  /  /    "}`,
                                                                    fontSize: 5,
                                                                    margin: [0, -5, 0, 0]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                ]
                                            },
                                            layout: "noBorders"
                                        },
                                        {
                                            table: {
                                                body: [
                                                    [
                                                        {
                                                            text: `Drug: ${inventoryItem.name ||
                                                                ""}`,
                                                            fontSize: 5,
                                                            bold: true
                                                        }
                                                    ],
                                                    [
                                                        {
                                                            text: [
                                                                {
                                                                    text: "Manufacturer: ",
                                                                    fontSize: 5,
                                                                    bold: true
                                                                },
                                                                {
                                                                    text: `${inventoryItem.labeler}`,
                                                                    fontSize: 5
                                                                }
                                                            ],
                                                            margin: [0, -4, 0, 0]
                                                        }
                                                    ]
                                                ]
                                            },
                                            layout: "noBorders"
                                        },
                                        {
                                            table: {
                                                widths: [20, 50, "*"],
                                                body: [
                                                    [
                                                        {
                                                            text: [
                                                                { text: "QTY: ", fontSize: 5, bold: true },
                                                                {
                                                                    text: `${currentClaim.quantity *
                                                                        inventoryItem.disQty || "N/A"}`,
                                                                    fontSize: 5
                                                                },
                                                                { text: `\n` },
                                                                { text: "DAW: ", fontSize: 5, bold: true },
                                                                { text: "0", fontSize: 5 }
                                                            ],
                                                            margin: [0, -2, 0, 0]
                                                        },
                                                        {
                                                            text: [
                                                                { text: "Refills: ", fontSize: 5, bold: true },
                                                                {
                                                                    text: `${claim.refills || "N/A"}`,
                                                                    fontSize: 5
                                                                },
                                                                { text: `\n` },
                                                                { text: "NDC: ", fontSize: 5, bold: true },
                                                                {
                                                                    text: `${inventoryItem.package || "N/A"}`,
                                                                    fontSize: 5
                                                                }
                                                            ],
                                                            margin: [-6, -2, 0, 0]
                                                        },
                                                        {
                                                            table: {
                                                                widths: [20, 50],
                                                                body: [
                                                                    [
                                                                        {
                                                                            text: "Lot/Exp: ",
                                                                            fontSize: 5,
                                                                            bold: true
                                                                        },
                                                                        {
                                                                            text: `${(claimLots &&
                                                                                claimLots
                                                                                    .map((claimLot) => "#" +
                                                                                    claimLot.siteLot.lotNumber +
                                                                                    " | " +
                                                                                    String(moment(claimLot.siteLot.expirationDate).format("MM/DD/YY")) +
                                                                                    "\n")
                                                                                    .join("")) ||
                                                                                "N/A"}`,
                                                                            fontSize: 4,
                                                                            margin: [-6, 0, 0, 0]
                                                                        }
                                                                    ]
                                                                ]
                                                            },
                                                            margin: [-12, -4, 0, 0],
                                                            layout: "noBorders"
                                                        }
                                                    ]
                                                ]
                                            },
                                            layout: "noBorders"
                                        },
                                        {
                                            table: {
                                                body: [
                                                    [
                                                        {
                                                            text: [
                                                                {
                                                                    text: `PRSCRBR:
                                  DEA/LIC:
                                  Employee Disp:`
                                                                }
                                                            ],
                                                            fontSize: 5,
                                                            bold: true
                                                        },
                                                        {
                                                            text: [
                                                                `${provider.lastName ||
                                                                    "N/A"}, ${provider.firstName || "N/A"}
                                ${provider.dea}
                                ${user.firstName[0]}. ${user.lastName}`
                                                            ],
                                                            fontSize: 5
                                                        }
                                                    ]
                                                ]
                                            },
                                            layout: "noBorders",
                                            margin: [0, 0, 0, 0]
                                        },
                                        {
                                            text: [
                                                `${site.address || "N/A"} ${currentClaim.order.site
                                                    .city || "N/A"}, ${site.state} ${site.zip ||
                                                    "N/A"} | ${currentClaim.order.site.phone ||
                                                    "(000) 000-0000"}`
                                            ],
                                            fontSize: 4,
                                            margin: [0, -2, 0, 0]
                                        },
                                        {
                                            table: {
                                                body: [
                                                    [
                                                        {
                                                            text: [
                                                                { text: "DATE: ", fontSize: 5, bold: true },
                                                                {
                                                                    text: `${moment(currentClaim.date).format("MM/DD/YYYY")}`,
                                                                    fontSize: 5
                                                                }
                                                            ],
                                                            margin: [0, 0, 0, 0]
                                                        },
                                                        {
                                                            text: [
                                                                { text: "COPAY: ", fontSize: 5, bold: true },
                                                                {
                                                                    text: `$${(((_g = (_f = currentClaim.copay) === null || _f === void 0 ? void 0 : _f.newPatientAmount) !== null && _g !== void 0 ? _g : currentClaim.patientAmount) / 100).toFixed(2)}`,
                                                                    fontSize: 5
                                                                }
                                                            ],
                                                            margin: [0, 0, 0, 0]
                                                        }
                                                    ]
                                                ]
                                            },
                                            layout: "noBorders"
                                        },
                                        {
                                            table: {
                                                widths: ["*", 110],
                                                body: [
                                                    [
                                                        {
                                                            text: "SIG:",
                                                            fontSize: 5,
                                                            margin: [0, -3, 0, 0],
                                                            bold: true
                                                        },
                                                        {
                                                            text: `${(inventoryItem.defaultSig &&
                                                                inventoryItem.defaultSig) ||
                                                                "N/A"}${inventoryItem.defaultSig2 &&
                                                                " - " + inventoryItem.defaultSig2}${currentClaim
                                                                .inventory.defaultSig3 &&
                                                                " - " + inventoryItem.defaultSig3}
                            `,
                                                            fontSize: 4,
                                                            margin: [-3, -3, 0, 0]
                                                        }
                                                    ]
                                                ]
                                            },
                                            layout: "noBorders"
                                        }
                                    ],
                                    style: "patientReceiptClone",
                                    width: 110
                                }
                            ]
                        ]
                    },
                    widths: [110]
                }
            ];
        };
    }
}
exports.ClaimLabel = ClaimLabel;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/sheets/claim-label/claim-label.ts
// module id = 2725
// module chunks = 0 1